<template>
    <div>
      <!-- modal -->
      <b-modal
        id="responsibleFieldFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="responsibleFieldFormModal"
        :title=" $t('responsibleField.info')"
        :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')"
        cancel-variant="outline-secondary"
        @ok.prevent="addOrUpdate"
      >
  
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col>
              <validation-provider
                #default="{ errors }"
                :name=" $t('responsibleField.name')"
                rules="required"
              >
              <label for="responsible-field-name-input">{{ $t('responsibleField.name') }}</label>
              <b-form-group>
                <b-form-input
                  id="responsible-field-name-input"
                  v-model="responsibleFieldName"
                  maxlength="50"
                  size="sm"
                  :state="errors.length > 0 ? false:null"
                />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getResponsibleFieldList: {type: Function}
    },
    data() {
      return {
        id: 0,
        responsibleFieldName: '',
      }
    },
    methods: {
      showInfo(id) {
        this.$refs['responsibleFieldFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'ResponsibleField'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.responsibleFieldName = response.data.responsibleField.name
            } else {
                this.$bvModal.hide('responsibleFieldFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, name: this.responsibleFieldName}
        const controller = {name : 'ResponsibleField'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save',payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('responsibleFieldFormModal')
                    this.getResponsibleFieldList()
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  